import { render, staticRenderFns } from "./EdInputTipo.vue?vue&type=template&id=7c198269&"
import script from "./EdInputTipo.vue?vue&type=script&lang=js&"
export * from "./EdInputTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports